import React from "react";

function ToyotaIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2500"
      height="2062"
      viewBox="0 0 283.465 233.771"
    >
      <path
        fill="#ab002f"
        d="M141.396 208.536c-.043-13.945 11.196-25.195 25.234-25.219 13.694.022 24.942 11.272 25.218 25.219-.273 13.789-11.521 25.039-25.218 25.234-14.038-.195-25.276-11.445-25.234-25.234zm25.235 15.938c7.578-.117 13.852-7.238 13.93-15.938-.078-8.867-6.352-15.988-13.93-15.938-7.906-.052-14.195 7.069-13.945 15.938-.25 8.699 6.039 15.82 13.945 15.938M220.391 193.927v38.515h-10.614v-38.515h-15.273v-8.617H235v8.617h-14.609M247.605 221.806l-3.974 10.637h-12.604l19.91-47.133h13.27l19.258 47.133H270.86l-3.983-10.637h-19.272zm9.973-7.957h6.629l-6.629-17.267-6.641 17.267h6.641M25.223 193.927v38.515H14.602v-38.515H0v-8.617h39.832v8.617H25.223M42.488 208.536c.021-13.945 11.254-25.195 25.214-25.219 13.78.022 25.03 11.272 25.233 25.219-.203 13.789-11.453 25.039-25.233 25.234-13.96-.195-25.194-11.445-25.214-25.234zm25.214 15.938c7.668-.117 13.937-7.238 13.944-15.938-.008-8.867-6.276-15.988-13.944-15.938-7.828-.052-14.108 7.069-13.925 15.938-.183 8.699 6.097 15.82 13.925 15.938M116.834 232.442h5.305v-17.93l18.593-29.202h-11.945l-11.953 19.906-11.289-19.906H92.936l18.593 29.202v17.93h5.305"
      />
      <path d="M8.547 81.561c0 44.972 58.476 81.562 130.35 81.562 71.873 0 130.35-36.59 130.35-81.562C269.246 36.585 210.77 0 138.896 0S8.547 36.585 8.547 81.561zm4 0c0-42.762 56.679-77.554 126.35-77.554 69.669 0 126.35 34.792 126.35 77.554 0 42.771-56.681 77.562-126.35 77.562-69.671-.001-126.35-34.79-126.35-77.562z" />
      <path d="M126.58 14.827c-30.508 1.863-52.667 9.949-56.444 20.602a9.999 9.999 0 0 0-.586 3.345c0 1.797.508 3.594 1.516 5.312C75.3 51.3 88.443 57.249 107.146 60.44l1.98.324.332-1.978c3.07-18.727 9.809-33.453 18.496-40.406l4.922-3.944-6.296.391zM74.519 42.069c-.652-1.109-.973-2.203-.973-3.281 0-.68.117-1.344.359-2.02 2.883-8.138 22.468-15.246 47.487-17.539-7.137 8.073-12.625 21.082-15.488 36.887-16.258-3.008-27.948-8.188-31.385-14.047zm-4.383-6.641zM121.002 59.983l-.391 2.176 2.207.168c5.234.391 10.645.602 16.074.602 5.434 0 10.848-.211 16.083-.602l2.203-.168-.392-2.176c-3.009-16.898-9.703-26.992-17.891-26.992-8.194 0-14.885 10.094-17.893 26.992zm17.894-22.992c5.598 0 10.766 8.383 13.489 21.469-4.427.289-8.936.469-13.493.469-4.551 0-9.062-.18-13.484-.469 2.715-13.086 7.891-21.469 13.488-21.469zM149.834 18.382c8.684 6.953 15.43 21.681 18.5 40.406l.328 1.978 1.977-.324c18.711-3.191 31.861-9.142 36.08-16.355 1.641-2.772 1.953-5.766.938-8.655-3.776-10.652-25.936-18.738-56.442-20.603l-6.288-.391 4.907 3.944zm6.574.847c25.012 2.293 44.596 9.414 47.471 17.539.25.676.367 1.34.367 2.02 0 1.078-.328 2.172-.965 3.281-3.449 5.858-15.143 11.039-31.393 14.047-2.863-15.804-8.343-28.813-15.48-36.887zM50.832 43.28C37.121 54.765 29.875 68.409 29.875 82.744c0 33.722 41.12 62.226 95.643 66.288l6.09.457-4.637-3.961c-11.945-10.219-19.363-34.465-19.363-63.28l.125-6.808-1.672-.34c-28.679-5.14-49.082-17.199-51.987-30.703l-.695-3.242-2.547 2.125zM33.879 82.744c0-12.292 5.996-24.089 17.254-34.335 5.245 13.645 24.843 25.012 52.545 30.301-.035 1.562-.066 3.538-.066 3.538 0 26.718 6.34 49.792 16.797 62.241-49.68-5.301-86.53-31.25-86.53-61.745zM119.373 79.14l-.012.726c0 26.784 8.398 46.991 19.535 46.991 11.133 0 19.532-20.207 19.532-46.991l-.027-2.89-2.148.184c-5.664.496-11.496.742-17.355.742s-11.699-.246-17.348-.742l-2.156-.195-.021 2.175zm35.031 2.147c-.301 24.921-8.152 41.573-15.508 41.573-7.363 0-15.215-16.652-15.508-41.573 5.086.375 10.281.609 15.508.609 5.235 0 10.415-.234 15.508-.609zM223.711 44.397c-2.902 13.504-23.309 25.562-51.979 30.703l-1.68.312.133 6.835c0 28.815-7.422 53.062-19.363 63.28l-4.637 3.961 6.082-.457c54.528-4.062 95.649-32.566 95.649-66.288 0-14.335-7.254-27.979-20.965-39.464l-2.539-2.125-.701 3.243zm2.941 4.012c11.266 10.246 17.266 22.043 17.266 34.335 0 30.495-36.848 56.444-86.533 61.745 10.457-12.449 16.797-35.523 16.797-62.241 0 0-.039-1.977-.066-3.538 27.693-5.289 47.29-16.657 52.536-30.301z" />
      <linearGradient
        id="aGradToyota"
        x1="-907.035"
        x2="-907.035"
        y1="1209.688"
        y2="1300.343"
        gradientTransform="matrix(1 0 0 -1 1045.93 1353.947)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#f0f3f5" />
        <stop offset=".056" stopColor="#e2e5e8" />
        <stop offset=".138" stopColor="#d4d8dd" />
        <stop offset=".242" stopColor="#ccd0d6" />
        <stop offset=".44" stopColor="#caced4" />
        <stop offset=".568" stopColor="#b3b7bd" />
        <stop offset=".835" stopColor="#797c83" />
        <stop offset="1" stopColor="#52545c" />
      </linearGradient>
      <path
        fill="url(#aGradToyota)"
        d="M225.129 34.101c.184.508.352 1.026.484 1.547.754 2.996.598 5.938-.379 8.805C238.242 55.18 245.91 68.41 245.91 82.745c0 35.78-47.914 64.792-107.014 64.792-59.104 0-107.014-29.012-107.014-64.792 0-14.323 7.676-27.564 20.668-38.292-.969-2.867-1.125-5.809-.371-8.805a9.638 9.638 0 0 1 .621-1.652c-17.75 12.646-28.512 29.219-28.512 47.37 0 39.632 51.308 71.757 114.607 71.757 63.291 0 114.607-32.125 114.607-71.757.002-18.113-10.717-34.648-28.373-47.265z"
      />
      <linearGradient
        id="bGradToyota"
        x1="-907.031"
        x2="-907.031"
        y1="1278.762"
        y2="1327.886"
        gradientTransform="matrix(1 0 0 -1 1045.93 1353.947)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#f0f3f5" />
        <stop offset=".056" stopColor="#e2e5e8" />
        <stop offset=".138" stopColor="#d4d8dd" />
        <stop offset=".242" stopColor="#ccd0d6" />
        <stop offset=".44" stopColor="#caced4" />
        <stop offset=".568" stopColor="#b3b7bd" />
        <stop offset=".835" stopColor="#797c83" />
        <stop offset="1" stopColor="#52545c" />
      </linearGradient>
      <path
        fill="url(#bGradToyota)"
        d="M154.818 60.335c-5.051.379-10.375.586-15.926.586-5.547 0-10.867-.207-15.918-.586h-.016l-3.301 2.398c6.09.531 12.521.832 19.238.832 6.718 0 13.148-.301 19.242-.832l-3.319-2.398zm58.541-25.141c-4.023-13.297-37.187-23.062-74.463-23.062-37.27 0-70.433 9.767-74.456 23.062-3.492 11.535 15.57 22.211 45.644 26.445l-2.613-3.181c-24.328-4.14-38.788-12.968-35.452-22.354 4.043-11.396 33.409-19.648 66.874-19.648 33.464 0 62.837 8.254 66.876 19.648 3.332 9.387-11.121 18.215-35.455 22.354l-2.604 3.181c30.063-4.234 49.138-14.91 45.649-26.445z"
      />
      <linearGradient
        id="cGradToyota"
        x1="-890.724"
        x2="-921.397"
        y1="1287.791"
        y2="1313.529"
        gradientTransform="matrix(1 0 0 -1 1045.93 1353.947)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#f0f3f5" />
        <stop offset=".056" stopColor="#e2e5e8" />
        <stop offset=".138" stopColor="#d4d8dd" />
        <stop offset=".242" stopColor="#ccd0d6" />
        <stop offset=".44" stopColor="#caced4" />
        <stop offset=".568" stopColor="#b3b7bd" />
        <stop offset=".835" stopColor="#797c83" />
        <stop offset="1" stopColor="#52545c" />
      </linearGradient>
      <path
        fill="url(#cGradToyota)"
        d="M123.014 60.335c2.793-15.52 8.852-25.219 15.879-25.219 7.035 0 13.089 9.699 15.886 25.219h.056l3.267 2.371c-2.758-20.496-10.312-33.594-19.204-33.594-8.898 0-16.449 13.098-19.203 33.594l3.266-2.371h.053z"
      />
      <linearGradient
        id="dGradToyota"
        x1="-887.604"
        x2="-932.331"
        y1="1244.974"
        y2="1270.797"
        gradientTransform="matrix(1 0 0 -1 1045.93 1353.947)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#f0f3f5" />
        <stop offset=".056" stopColor="#e2e5e8" />
        <stop offset=".138" stopColor="#d4d8dd" />
        <stop offset=".242" stopColor="#ccd0d6" />
        <stop offset=".44" stopColor="#caced4" />
        <stop offset=".568" stopColor="#b3b7bd" />
        <stop offset=".835" stopColor="#797c83" />
        <stop offset="1" stopColor="#52545c" />
      </linearGradient>
      <path
        fill="url(#dGradToyota)"
        d="M159.092 74.319l-2.672 4.832c0 .352.016.714.016 1.081 0 25.726-7.867 45.232-17.542 45.232-9.684 0-17.535-19.508-17.535-45.232 0-.406.008-.809.016-1.198l-2.676-4.715a145.44 145.44 0 0 0-.117 5.886c0 29.167 9.094 51.261 20.316 51.261s20.324-22.094 20.324-51.261a147.012 147.012 0 0 0-.13-5.886z"
      />
      <linearGradient
        id="eGradToyota"
        x1="-922.726"
        x2="-922.726"
        y1="1351.951"
        y2="1274.035"
        gradientTransform="matrix(1 0 0 -1 1045.93 1353.947)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#f0f3f5" />
        <stop offset=".056" stopColor="#e2e5e8" />
        <stop offset=".138" stopColor="#d4d8dd" />
        <stop offset=".242" stopColor="#ccd0d6" />
        <stop offset=".44" stopColor="#caced4" />
        <stop offset=".568" stopColor="#b3b7bd" />
        <stop offset=".835" stopColor="#797c83" />
        <stop offset="1" stopColor="#52545c" />
      </linearGradient>
      <path
        fill="url(#eGradToyota)"
        d="M110.127 61.651c3.844-28.488 15.27-49.521 28.77-49.521-14.473 0-26.809 18.634-31.387 46.384l2.578 3.137h.039z"
      />
      <linearGradient
        id="fGradToyota"
        x1="-891.344"
        x2="-891.344"
        y1="1351.951"
        y2="1274.035"
        gradientTransform="matrix(1 0 0 -1 1045.93 1353.947)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#f0f3f5" />
        <stop offset=".056" stopColor="#e2e5e8" />
        <stop offset=".138" stopColor="#d4d8dd" />
        <stop offset=".242" stopColor="#ccd0d6" />
        <stop offset=".44" stopColor="#caced4" />
        <stop offset=".568" stopColor="#b3b7bd" />
        <stop offset=".835" stopColor="#797c83" />
        <stop offset="1" stopColor="#52545c" />
      </linearGradient>
      <path
        fill="url(#fGradToyota)"
        d="M167.67 61.651h.027l2.578-3.137c-4.57-27.75-16.914-46.384-31.379-46.384 13.5.002 24.934 21.033 28.774 49.521z"
      />
      <linearGradient
        id="gGradToyota"
        x1="-890.393"
        x2="-890.393"
        y1="1352.606"
        y2="1222.572"
        gradientTransform="matrix(1 0 0 -1 1045.93 1353.947)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#f0f3f5" />
        <stop offset=".056" stopColor="#e2e5e8" />
        <stop offset=".138" stopColor="#d4d8dd" />
        <stop offset=".242" stopColor="#ccd0d6" />
        <stop offset=".44" stopColor="#caced4" />
        <stop offset=".568" stopColor="#b3b7bd" />
        <stop offset=".835" stopColor="#797c83" />
        <stop offset="1" stopColor="#52545c" />
      </linearGradient>
      <path
        fill="url(#gGradToyota)"
        d="M172.072 77.053l-3.281-3.918h-.027c.184 3.113.289 6.277.289 9.491 0 38.934-13.504 70.495-30.156 70.495 18.671 0 33.281-29.272 33.281-70.495 0-1.886-.039-3.736-.106-5.573z"
      />
      <linearGradient
        id="hGradToyota"
        x1="-923.675"
        x2="-923.675"
        y1="1352.606"
        y2="1222.572"
        gradientTransform="matrix(1 0 0 -1 1045.93 1353.947)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#f0f3f5" />
        <stop offset=".056" stopColor="#e2e5e8" />
        <stop offset=".138" stopColor="#d4d8dd" />
        <stop offset=".242" stopColor="#ccd0d6" />
        <stop offset=".44" stopColor="#caced4" />
        <stop offset=".568" stopColor="#b3b7bd" />
        <stop offset=".835" stopColor="#797c83" />
        <stop offset="1" stopColor="#52545c" />
      </linearGradient>
      <path
        fill="url(#hGradToyota)"
        d="M108.748 82.627c0-3.214.105-6.378.285-9.491h-.022l-3.289 3.906a155.884 155.884 0 0 0-.109 5.585c0 41.223 14.621 70.495 33.285 70.495-16.646 0-30.15-31.562-30.15-70.495z"
      />
      <path
        fill="#2d2f34"
        d="M225.234 44.452c4.973 4.102 9.168 8.578 12.449 13.332a45.87 45.87 0 0 0-8.75-20.82 89.125 89.125 0 0 0-3.806-2.862c.185.508.353 1.026.483 1.547.757 2.995.601 5.936-.376 8.803zM52.551 44.452c-.969-2.867-1.125-5.809-.371-8.805a9.638 9.638 0 0 1 .621-1.652 119.88 119.88 0 0 0-3.941 2.969 46.053 46.053 0 0 0-8.75 20.82c3.281-4.754 7.468-9.231 12.441-13.332z"
      />
      <linearGradient
        id="iGradToyota"
        x1="-907.038"
        x2="-907.038"
        y1="1351.944"
        y2="1192.832"
        gradientTransform="matrix(1 0 0 -1 1045.93 1353.947)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#f0f3f5" />
        <stop offset=".253" stopColor="#edf0f3" />
        <stop offset=".406" stopColor="#e5e8ea" />
        <stop offset=".531" stopColor="#d7dadc" />
        <stop offset=".642" stopColor="#c3c5c9" />
        <stop offset=".744" stopColor="#a9abaf" />
        <stop offset=".839" stopColor="#888b90" />
        <stop offset=".926" stopColor="#63656b" />
        <stop offset="1" stopColor="#3d3f46" />
      </linearGradient>
      <path
        fill="url(#iGradToyota)"
        d="M10.547 81.561c0-43.934 57.46-79.558 128.35-79.558 70.88 0 128.341 35.624 128.341 79.558 0 43.943-57.461 79.554-128.341 79.554-70.89-.001-128.35-35.61-128.35-79.554zm128.349 71.561c63.292 0 114.607-32.125 114.607-71.757 0-39.636-51.315-71.772-114.607-71.772-63.3 0-114.611 32.138-114.611 71.772 0 39.632 51.312 71.757 114.611 71.757z"
      />
      <linearGradient
        id="jGradToyota"
        x1="-907.03"
        x2="-907.03"
        y1="1351.952"
        y2="1192.83"
        gradientTransform="matrix(1 0 0 -1 1045.93 1353.947)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#f0f3f5" />
        <stop offset=".253" stopColor="#edf0f3" />
        <stop offset=".406" stopColor="#e5e8ea" />
        <stop offset=".531" stopColor="#d7dadc" />
        <stop offset=".642" stopColor="#c3c5c9" />
        <stop offset=".744" stopColor="#a9abaf" />
        <stop offset=".839" stopColor="#888b90" />
        <stop offset=".926" stopColor="#63656b" />
        <stop offset="1" stopColor="#3d3f46" />
      </linearGradient>
      <path
        fill="url(#jGradToyota)"
        d="M108.748 82.627c0-38.525 13.504-70.495 30.148-70.495 16.652 0 30.157 31.97 30.157 70.495 0 38.934-13.505 70.495-30.157 70.495s-30.148-31.562-30.148-70.495zm30.148 48.839c11.223 0 20.325-22.094 20.325-51.249 0-30.257-9.103-51.104-20.325-51.104S118.58 49.96 118.58 80.217c0 29.155 9.094 51.249 20.316 51.249z"
      />
      <linearGradient
        id="kGradToyota"
        x1="-907.034"
        x2="-907.034"
        y1="1351.935"
        y2="1192.817"
        gradientTransform="matrix(1 0 0 -1 1045.93 1353.947)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#f0f3f5" />
        <stop offset=".253" stopColor="#edf0f3" />
        <stop offset=".406" stopColor="#e5e8ea" />
        <stop offset=".531" stopColor="#d7dadc" />
        <stop offset=".642" stopColor="#c3c5c9" />
        <stop offset=".744" stopColor="#a9abaf" />
        <stop offset=".839" stopColor="#888b90" />
        <stop offset=".926" stopColor="#63656b" />
        <stop offset="1" stopColor="#3d3f46" />
      </linearGradient>
      <path
        fill="url(#kGradToyota)"
        d="M52.18 35.647C55.488 22.55 95.494 3.488 138.896 3.488c43.398 0 82.03 13.62 86.717 32.159 5.246 20.78-33.309 39.586-86.717 39.586-53.417 0-91.97-18.805-86.716-39.586zm86.716-23.515c-37.27 0-70.433 9.767-74.456 23.062-4.508 14.895 28.593 28.371 74.456 28.371 45.872 0 78.967-13.478 74.463-28.371-4.023-13.297-37.185-23.062-74.463-23.062z"
      />
      <linearGradient
        id="lGradToyota"
        x1="-907.033"
        x2="-907.033"
        y1="1318.944"
        y2="1273.596"
        gradientTransform="matrix(1 0 0 -1 1045.93 1353.947)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#caced4" />
        <stop offset="1" stopColor="#52545c" />
      </linearGradient>
      <path
        fill="url(#lGradToyota)"
        d="M118.658 74.28l.023.016 2.754 4.855c5.605.479 11.434.753 17.461.753 6.055 0 11.898-.273 17.54-.765l2.68-4.845.016-.016c-6.445.613-13.203.953-20.234.953a213.256 213.256 0 0 1-20.24-.951zm107.408-34.14c-.688 14.858-23.527 28.022-57.287 32.983l.012.012 3.293 3.935c33.033-5.938 54.764-20.524 53.982-36.93zm-174.339 0c-.781 16.422 20.948 30.991 53.975 36.93l3.301-3.935.008-.012c-33.766-4.96-56.589-18.124-57.284-32.983z"
      />
    </svg>
  );
}
export default ToyotaIcon;
